import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Alert, AlertTitle } from '@mui/material'

import { describeImportStatus } from '../../helpers/importToolHelpers'
import { ImportStatus, ImportType } from '../../types/ImportTool'

const labelKeys = {
  [ImportType.Weight]: {
    importing: 'internal-analysts:import_tool_weights_importing',
    succeeded: 'internal-analysts:import_tool_last_weights_succeeded',
    failed: 'internal-analysts:import_tool_last_weights_failed',
  },
  [ImportType.Features]: {
    importing: 'internal-analysts:import_tool_features_importing',
    succeeded: 'internal-analysts:import_tool_last_features_succeeded',
    failed: 'internal-analysts:import_tool_last_features_failed',
  },
}

type ImportStatusAlertProps = {
  type: ImportType
  status: ImportStatus
  now: number
}

export const ImportStatusAlert: FC<ImportStatusAlertProps> = ({ type, status, now }) => {
  const { t } = useTranslation()
  const summary = describeImportStatus(status, now)
  const keys = labelKeys[type]

  if (summary.state === 'never') return null

  if (summary.state === 'updating') {
    return (
      <Alert severity="info">
        <AlertTitle>{t(keys.importing)}</AlertTitle>
        {t('internal-analysts:import_tool_started_elapsed', { started: summary.started, elapsed: summary.elapsed })}
      </Alert>
    )
  }

  return (
    <Alert severity={summary.state === 'succeeded' ? 'success' : 'error'}>
      {t(keys[summary.state], { duration: summary.duration, started: summary.started })}
    </Alert>
  )
}
